module.exports = __webpack_public_path__ + "media/images/riders/WYN_MASTERS-555efdb564bc91299ea5078de3ab6dba.png";